module.exports = {
    title: "scholarship",
    crud: {
        create: "Create Scholarship",
        edit: "Edit Scholarship",
    },
    table: {
        columns: [
            "title",
            "users",
            "scholarshipTypeTitle",
            "startDate",
            "endDate",
            "isVerified",
            "actions",
        ],
        headings: {
            title: "Title",
            users: "User",
            scholarshipTypeTitle: "Type",
            startDate: "Start Date",
            endDate: "End Date",
            isVerified: "Verification Status",
            // 'isActive': 'Status',
            actions: "Actions",
        }
    },
    form: {
        title: "Title",
    },
    validation: {
        required: {
            title: "Title is required",
            type: "Type is required",
            summary: "Summary is required",
            benefits: "Benefits is required",
            start_date: 'Start date is required',
            startDate: 'Start date is required',
            end_date: 'End date is required',
            endDate: 'End date is required',
            application_mode: 'Application mode is required',
        },
    },
};
